import { render, staticRenderFns } from "./AdditionalDataClient.vue?vue&type=template&id=1845f3ac&scoped=true"
import script from "./AdditionalDataClient.vue?vue&type=script&lang=js"
export * from "./AdditionalDataClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1845f3ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1845f3ac')) {
      api.createRecord('1845f3ac', component.options)
    } else {
      api.reload('1845f3ac', component.options)
    }
    module.hot.accept("./AdditionalDataClient.vue?vue&type=template&id=1845f3ac&scoped=true", function () {
      api.rerender('1845f3ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/AdditionalDataClient.vue"
export default component.exports